import type { FC } from 'react';
import React from 'react';

import { Box } from '@mui/material';

import { CrossSmallIcon } from '@setup/svg-icons/svg-icons';
import theme from '@setup/theme/theme';

import type { OptionType } from './types';
import type { ClearIndicatorProps } from 'react-select';

export const ClearIndicator: FC<ClearIndicatorProps<OptionType>> = ({
  clearValue,
  isFocused,
  selectProps: { isDisabled },
}) => {
  const onClear = () => clearValue();

  return (
    <Box
      onClick={onClear}
      onTouchStart={onClear}
      sx={{
        position: 'relative',
        zIndex: '100',
        width: '24px',
        height: '24px',
        paddingLeft: '4px',
        display: isFocused ? 'flex' : 'none',
        alignItems: 'center',
        cursor: 'pointer !important',
        color: `${isDisabled ? theme.palette.case.neutral.n300 : theme.palette.case.neutral.n500} !important`,

        svg: {
          width: '18px',
          path: { fill: 'currentcolor' },
        },

        '&:hover': {
          opacity: '0.7',
        },
      }}
    >
      <CrossSmallIcon />
    </Box>
  );
};
